import { render, staticRenderFns } from "./web_ide_link.vue?vue&type=template&id=0a46ba0b"
import script from "./web_ide_link.vue?vue&type=script&lang=js"
export * from "./web_ide_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports